// extracted by mini-css-extract-plugin
export var discard = "_1u-4";
export var muiTooltipTooltip = "_1u-6";
export var notificationBar = "_1u-3";
export var notificationContainer = "_1u-2";
export var saveButtonHoverSlotWrapper = "_1u-5";
export var show = "_1u-1";
export var spacer = "_1u-0";